import React from 'react'

import ItemPriceAndCTAs from '../common/ItemPriceAndCTAs'
import { DetailItemCardVariant } from '../common/types'

import {
  CruiseItem,
  SavedCruiseData,
} from 'tripPlanner/types/tripItem'
import { buildProductLink } from 'tripPlanner/utils/bookmark/restoreCart'
import CruiseV2OfferPriceDetails from 'tripPlanner/components/ItemOfferPrice/CruiseV2OfferPriceDetails'
import CruiseV2SavedPriceDetails from 'tripPlanner/components/ItemOfferPrice/CruiseV2SavedPriceDetails'
import CruiseCtaContent from '../CTAContent/CruiseCtaContent'

interface Props {
  item: CruiseItem & { savedItemData: Extract<SavedCruiseData, { offerType: 'cruise' }> }
  viewAsTemplate: boolean
  variant: DetailItemCardVariant
}

function TourV2PriceAndCTAs({ item, viewAsTemplate, variant }: Props) {
  const offerLink = buildProductLink(item, !viewAsTemplate) ?? ''
  const { price, currencyCode, cabinCategory, isOfferSoldOut } =
    item.savedItemData
  const isOfferAvailable = !isOfferSoldOut && !!price
  let priceAreaContent: JSX.Element | null = null

  if (item.isSuggested) {
    // We don't currently do suggested cruises. If we ever do, update this.
    return null
  }

  if (viewAsTemplate) {
    priceAreaContent = (
      <CruiseV2OfferPriceDetails offerId={item.savedItemData.offerId} />
    )
  } else {
    priceAreaContent = (
      <CruiseV2SavedPriceDetails
        price={price}
        currencyCode={currencyCode}
        cabinCategory={cabinCategory}
        isOfferAvailable={isOfferAvailable}
      />
    )
  }

  const ctaAreaContent = (
    <CruiseCtaContent
      item={item}
      isOfferAvailable={isOfferAvailable}
      variant={variant}
      offerLink={offerLink}
    />
  )

  return (
    <ItemPriceAndCTAs>
      {priceAreaContent && <div className="price-area">{priceAreaContent}</div>}
      {ctaAreaContent && <div className="cta-area">{ctaAreaContent}</div>}
    </ItemPriceAndCTAs>
  )
}

export default TourV2PriceAndCTAs
